<div class="backdrop"></div>
<div class="toast-box">
  <img src="../../../assets/images/warningIcon.svg" alt="error_icon" />
  <p>
    {{ message }}
  </p>
</div>
